import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { authHeader } from '../services/auth-header';
import { BASE_URL } from '../services/Api';
import { Card } from 'react-bootstrap';
import Swal from 'sweetalert2';

const ImageView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { pointindex } = useParams();
  const [fileData, setFileData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(BASE_URL + 'drawing/findById/' + id, {
          headers: authHeader(),
          responseType: 'arraybuffer'
        });

        setFileData(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching file data:', error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const getFileType = () => {
    if (!fileData) return '';

    const uint = new Uint8Array(fileData.slice(0, 4));
    let bytes = [];
    uint.forEach((byte) => {
      bytes.push(byte.toString(16));
    });
    const hex = bytes.join('').toUpperCase();

    switch (hex) {
      case '89504E47':
        return 'image/png';
      case '47494638':
        return 'image/gif';
      case '25504446':
        return 'application/pdf';
      case 'FFD8FFDB':
      case 'FFD8FFE0':
        return 'image/jpeg';
      default:
        return '';
    }
  };

  const displayFile = () => {
    const fileType = getFileType();

    if (loading) {
      return <p>Loading...</p>;
    } else if (!fileData || fileType === '') {
      return <p>No file data found</p>;
    } else {
      switch (fileType) {
        case 'image/png':
        case 'image/jpeg':
        case 'image/gif':
          const base64Data = arrayBufferToBase64(fileData);
          return <iframe style={{ width: '100%', height: '600px' }} src={`data:${fileType};base64,${base64Data}`} alt="Fetched" />;
        case 'application/pdf':
          const blob = new Blob([fileData], { type: 'application/pdf' });
          const url = URL.createObjectURL(blob);
          return <iframe src={url} style={{ width: '100%', height: '600px' }} title="PDF Viewer" />;
        default:
          return <p>Unsupported file type</p>;
      }
    }
  };

  const arrayBufferToBase64 = (buffer) => {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  };

  const getItem = (id) => {

    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {

        axios.delete(BASE_URL + "drawing/delete/" + id, {
          headers: authHeader(),
        }
        ).then(res => {
          console.log(res.data)
          navigate(`/imagetabledindex/${pointindex}`)
        })
        Swal.fire(
          'Deleted!',
          'Deleted successfully.',
          'success'
        )
      }
    })
      .catch((error) => {
        // alert(error.response.data);
        Swal.fire(error.response.data);
        // console.log(error.response.data);
      })
  };

  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6>VIEW DRAWING  </h6>
          <div className="view-buttons">
            <Link><button className="button-70" onClick={() => getItem(id)}>DELETE</button></Link>
            <Link to="/imagetabledindex/1">
              <button className="button-70">BACK</button>
            </Link>
          </div>
        </Card.Header>
        <Card.Body>
          <div>
            {displayFile()}
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default ImageView;